import { createStore } from 'vuex'
import inspection from './inspection'
import inspection_call from './inspection_call'
import inspection_image from './inspection_image'
import inspection_item from './inspection_item'
import inspection_master from './inspection_master'
import inspection_reason_interrupted from './inspection_reason_interrupted'
import inspection_result from './inspection_result'
import inspection_result_interrupted from './inspection_result_interrupted'
import inspection_type from './inspection_type'

const store = createStore({
  actions: {
    clearAllStores({ dispatch }) {
      dispatch('inspection_call/clearAll', null, { root: true })
      dispatch('inspection_image/clearAll', null, { root: true })
      dispatch('inspection_item/clearAll', null, { root: true })
      dispatch('inspection_master/clearAll', null, { root: true })
      dispatch('inspection_result/clearAll', null, { root: true })
      dispatch('inspection_type/clearAll', null, { root: true })
      dispatch('inspection/clearAll', null, { root: true })
      dispatch('inspection_result_interrupted/clearAll', null, { root: true })
      dispatch('inspection_reason_interrupted/clearAll', null, { root: true })
    },
    clearDataStores({ dispatch }) {
      dispatch('inspection_call/clearAll', null, { root: true })
      dispatch('inspection_image/clearAll', null, { root: true })
      dispatch('inspection_item/clearAll', null, { root: true })
      dispatch('inspection_master/clearAll', null, { root: true })
      dispatch('inspection_result/clearAll', null, { root: true })
      dispatch('inspection_type/clearAll', null, { root: true })
      dispatch('inspection/clearAll', null, { root: true })
      dispatch('inspection_result_interrupted/clearAll', null, { root: true })
      dispatch('inspection_reason_interrupted/clearAll', null, { root: true })
    },
  },
  modules: {
    inspection_call,
    inspection_image,
    inspection_item,
    inspection_master,
    inspection_result,
    inspection_type,
    inspection,
    inspection_result_interrupted,
    inspection_reason_interrupted,
  },
})

export default store
